import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Button from 'components/Button';
import Icon from 'components/Icon';
import Title from 'components/Title';
import Field from 'components/Field';
import Success from 'components/Success';
import Error from 'components/Error';

import styles from './PasswordRecovery.module.css';

const cx = classNames.bind(styles);

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;

export default class PublicPasswordRecovery extends PureComponent {
  static propTypes = {
    email: PropTypes.string,
    error: PropTypes.string,
    submitting: PropTypes.bool,
    success: PropTypes.bool,
    valid: PropTypes.bool,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
  }

  static defaultProps = {
    email: undefined,
    error: undefined,
    submitting: false,
    success: false,
    valid: false,
    onCancel: () => {},
    onSubmit: () => {},
  }

  getTitle = R.memoizeWith(R.identity, email => {
    return (
      <>
        {isMobile ?
          <span>
            Пароль выслан
            <br />
            на почту {email}
          </span>
            :
          <span>
            Пароль выслан
            <br />
            на <b>{email}</b>
          </span>
        }
      </>
    )});

  renderForm() {
    const { onSubmit, onCancel, error, submitting } = this.props;

    return (
      <form onSubmit={onSubmit} className={cx('form')} noValidate>

        {!isMobile ?
          <div className={cx('circle')}>
            <Icon icon='recovery' width={50} height={40} />
          </div>
          :
          <div className={cx('link')}>
            <Button
              onClick={onCancel}
              customClass={'button_recover'}
            >
              <Icon icon='arrow-left-mobile' width={16} height={16} />
            </Button>
          </div>
        }

        <div className={cx('title')}>
          <Title isRegistration={isMobile}>Восстановление <br /> пароля</Title>
        </div>

        <div className={cx('field', {field_recovery: isMobile})}>
          <Field
            name='email'
            type='email'
            placeholder={!isMobile && 'Адрес почты, на которую зарегистрирован аккаунт'}
            isRegistration={isMobile}
            additionalText={<>Введите адрес эл. почты, на которую <br /> зарегистрирован аккаунт </>}
          />
        </div>

        {error && <Error error={error} />}

        <div className={cx('buttons')}>
          <Button
            type='submit'
            isLoading={submitting}
            disabled={!this.props.valid || submitting}
            upper={!isMobile}
            customClass={isMobile && 'button--registration'}
            bordered={isMobile}
          >
            {isMobile ? 'Восстановить' : 'Восстановить пароль'}
          </Button>

          {!isMobile &&
            <Button
              onClick={onCancel}
              bordered
              upper
            >
              Отмена
            </Button>
          }
        </div>
      </form>
    );
  }

  renderSuccess() {
    const { email } = this.props;

    return (
      <div className={cx('success')}>
        {isMobile && <div></div>}
        <Success>
          {this.getTitle(email)}
        </Success>
        <div className={cx('successButton')}>
          <Button
            onClick={this.props.onCancel}
            bordered
            upper={!isMobile}
            block
            customClass={isMobile && 'button--registration'}
          >
            {isMobile ? 'Спасибо' : 'ОК'}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { success } = this.props;

    return (
      <div className={cx('passwordRecovery')}>
        {success ? this.renderSuccess() : this.renderForm()}
      </div>
    );
  }
}
